import { createApp } from './main'
import router from './router/router'

// 兼容 hash 模式的旧链接：/foreign#/set_up/xxx?a=1 → /hxws/set_up/xxx?a=1
// history 模式下 vue-router 不解析 #/ 之后的内容，需在创建应用前改写地址
function redirectLegacyHashRoute() {
    if (window.location.hash.indexOf('#/') !== 0) return false
    const hashPath = window.location.hash.slice(1) // 形如 /set_up/xxx?a=1
    const search = window.location.search // hash 之前的 query（如 SSO 回跳参数）
    // 改写后的地址需要带上路由公共目录（如 /hxws），否则会跳到根路径
    const base = (router.options.base || '').replace(/\/$/, '')
    const url = base + hashPath + (search ? (hashPath.indexOf('?') > -1 ? '&' : '?') + search.slice(1) : '')
    window.location.replace(url)
    return true
}

// 命中改写时不创建应用，让这次整页导航先提交，避免路由守卫抢先跳 SSO 顶掉它
if (!redirectLegacyHashRoute()) {
    const { app, router, store } = createApp()
    if (window.__INITIAL_STATE__) {
        store.replaceState(window.__INITIAL_STATE__)
    }
    router.onReady(() => {
        app.$mount('#app')
    })
}